import './Alignment.css';
import '../DataTable.css';
import '../../../core/components/app-root/AppRoot.css';
import './DataTableVirtualizationContainer.css';
import '../features/RowOrder/RowOrder.css';
import '../features/RowDetails/RowDetails.css';
import '../features/RowInteractivity/RowInteractivity.css';
import './DataTableRow.css';
import '../features/ColumnSizing/ColumnSizing.css';
import '../features/Thresholds/Thresholds.css';
import './DataTableCell.css';
import '../features/ColumnOrder/ColumnOrder.css';
import './DataTableHeaderCell.css';
import './DataTableDefaultCell.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var defaultCell = _7a468({defaultClassName:'_14k72810-3-12-1',variantClassNames:{lineWrap:{true:'_14k72811-3-12-1',false:'_14k72812-3-12-1'},rowDensity:{'default':'_14k72813-3-12-1',condensed:'_14k72814-3-12-1',comfortable:'_14k72815-3-12-1'}},defaultVariants:{rowDensity:'default'},compoundVariants:[]});